<div class="search-not-found lh-normal text-center">
  <app-svg-page-placeholder class="w-100"
      [height]="isMobile || sm ? 120: 180"
      [width]="isMobile || sm ? 250: 350"
      [backgroundImage]="bgConfig"
      [standImage]="standConfig">
  </app-svg-page-placeholder>
  <label class="fw-bold mb-1"
      [ngClass]="sm ? 'fs-u0': 'fs-base-u5'">
    {{ 'SEARCH-NOT-FOUND.TITLE' | translate }}
  </label>
  <label class="mb-0 text-gray-neutrals"
      [ngClass]="sm ? 'fs-l2': 'fs-u0'">
    {{ 'SEARCH-NOT-FOUND.SUB-1' | translate }}
  </label>
  <label class="mb-0 text-gray-neutrals"
      [ngClass]="sm ? 'fs-l2': 'fs-u0'">
    {{ 'SEARCH-NOT-FOUND.SUB-2' | translate }}
  </label>
</div>